import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { errorPrefix, generatedAttribute } from "./Utils/Constants";
import { getLogger, isBoolean, isFunction, isNumber, isString, itemFromSingleOrMultiple } from "../Utils/Utils";
import { Container } from "./Container";
import { EventDispatcher } from "../Utils/EventDispatcher";
import { Plugins } from "./Utils/Plugins";
import { getRandom } from "../Utils/NumberUtils";

function getDataFromUrl(_x) {
  return _getDataFromUrl.apply(this, arguments);
}

function _getDataFromUrl() {
  _getDataFromUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(data) {
    var url, response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            url = itemFromSingleOrMultiple(data.url, data.index);

            if (url) {
              _context15.next = 3;
              break;
            }

            return _context15.abrupt("return", data.fallback);

          case 3:
            _context15.next = 5;
            return fetch(url);

          case 5:
            response = _context15.sent;

            if (!response.ok) {
              _context15.next = 8;
              break;
            }

            return _context15.abrupt("return", response.json());

          case 8:
            getLogger().error("".concat(errorPrefix, " ").concat(response.status, " while retrieving config file"));
            return _context15.abrupt("return", data.fallback);

          case 10:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _getDataFromUrl.apply(this, arguments);
}

function isParamsEmpty(params) {
  return !params.id && !params.element && !params.url && !params.options;
}

function isParams(obj) {
  return !isParamsEmpty(obj);
}

export var Engine = /*#__PURE__*/function () {
  function Engine() {
    _classCallCheck(this, Engine);

    this._configs = new Map();
    this._domArray = [];
    this._eventDispatcher = new EventDispatcher();
    this._initialized = false;
    this.plugins = new Plugins(this);
  }

  _createClass(Engine, [{
    key: "configs",
    get: function get() {
      var res = {};

      var _iterator = _createForOfIteratorHelper(this._configs),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              name = _step$value[0],
              config = _step$value[1];

          res[name] = config;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return res;
    }
  }, {
    key: "version",
    get: function get() {
      return "2.11.0";
    }
  }, {
    key: "addConfig",
    value: function addConfig(nameOrConfig, config) {
      if (isString(nameOrConfig)) {
        if (config) {
          config.name = nameOrConfig;

          this._configs.set(nameOrConfig, config);
        }
      } else {
        var _nameOrConfig$name;

        this._configs.set((_nameOrConfig$name = nameOrConfig.name) !== null && _nameOrConfig$name !== void 0 ? _nameOrConfig$name : "default", nameOrConfig);
      }
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(type, listener) {
      this._eventDispatcher.addEventListener(type, listener);
    }
  }, {
    key: "addInteractor",
    value: function () {
      var _addInteractor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, interactorInitializer) {
        var refresh,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                refresh = _args.length > 2 && _args[2] !== undefined ? _args[2] : true;
                this.plugins.addInteractor(name, interactorInitializer);
                _context.next = 4;
                return this.refresh(refresh);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addInteractor(_x2, _x3) {
        return _addInteractor.apply(this, arguments);
      }

      return addInteractor;
    }()
  }, {
    key: "addMover",
    value: function () {
      var _addMover = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, moverInitializer) {
        var refresh,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                refresh = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : true;
                this.plugins.addParticleMover(name, moverInitializer);
                _context2.next = 4;
                return this.refresh(refresh);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addMover(_x4, _x5) {
        return _addMover.apply(this, arguments);
      }

      return addMover;
    }()
  }, {
    key: "addParticleUpdater",
    value: function () {
      var _addParticleUpdater = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(name, updaterInitializer) {
        var refresh,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                refresh = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : true;
                this.plugins.addParticleUpdater(name, updaterInitializer);
                _context3.next = 4;
                return this.refresh(refresh);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function addParticleUpdater(_x6, _x7) {
        return _addParticleUpdater.apply(this, arguments);
      }

      return addParticleUpdater;
    }()
  }, {
    key: "addPathGenerator",
    value: function () {
      var _addPathGenerator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(name, generator) {
        var refresh,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                refresh = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : true;
                this.plugins.addPathGenerator(name, generator);
                _context4.next = 4;
                return this.refresh(refresh);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addPathGenerator(_x8, _x9) {
        return _addPathGenerator.apply(this, arguments);
      }

      return addPathGenerator;
    }()
  }, {
    key: "addPlugin",
    value: function () {
      var _addPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(plugin) {
        var refresh,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                refresh = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : true;
                this.plugins.addPlugin(plugin);
                _context5.next = 4;
                return this.refresh(refresh);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function addPlugin(_x10) {
        return _addPlugin.apply(this, arguments);
      }

      return addPlugin;
    }()
  }, {
    key: "addPreset",
    value: function () {
      var _addPreset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(preset, options) {
        var override,
            refresh,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                override = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : false;
                refresh = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : true;
                this.plugins.addPreset(preset, options, override);
                _context6.next = 5;
                return this.refresh(refresh);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function addPreset(_x11, _x12) {
        return _addPreset.apply(this, arguments);
      }

      return addPreset;
    }()
  }, {
    key: "addShape",
    value: function () {
      var _addShape = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(shape, drawer, initOrRefresh, afterEffectOrRefresh, destroyOrRefresh) {
        var refresh,
            customDrawer,
            realRefresh,
            realInit,
            realAfterEffect,
            realDestroy,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                refresh = _args7.length > 5 && _args7[5] !== undefined ? _args7[5] : true;
                realRefresh = refresh;

                if (isBoolean(initOrRefresh)) {
                  realRefresh = initOrRefresh;
                  realInit = undefined;
                } else {
                  realInit = initOrRefresh;
                }

                if (isBoolean(afterEffectOrRefresh)) {
                  realRefresh = afterEffectOrRefresh;
                  realAfterEffect = undefined;
                } else {
                  realAfterEffect = afterEffectOrRefresh;
                }

                if (isBoolean(destroyOrRefresh)) {
                  realRefresh = destroyOrRefresh;
                  realDestroy = undefined;
                } else {
                  realDestroy = destroyOrRefresh;
                }

                if (isFunction(drawer)) {
                  customDrawer = {
                    afterEffect: realAfterEffect,
                    destroy: realDestroy,
                    draw: drawer,
                    init: realInit
                  };
                } else {
                  customDrawer = drawer;
                }

                this.plugins.addShapeDrawer(shape, customDrawer);
                _context7.next = 9;
                return this.refresh(realRefresh);

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function addShape(_x13, _x14, _x15, _x16, _x17) {
        return _addShape.apply(this, arguments);
      }

      return addShape;
    }()
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(type, args) {
      this._eventDispatcher.dispatchEvent(type, args);
    }
  }, {
    key: "dom",
    value: function dom() {
      return this._domArray;
    }
  }, {
    key: "domItem",
    value: function domItem(index) {
      var dom = this.dom(),
          item = dom[index];

      if (!item || item.destroyed) {
        dom.splice(index, 1);
        return;
      }

      return item;
    }
  }, {
    key: "init",
    value: function init() {
      if (this._initialized) {
        return;
      }

      this._initialized = true;
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(tagIdOrOptionsOrParams, options) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.loadFromArray(tagIdOrOptionsOrParams, options));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function load(_x18, _x19) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "loadFromArray",
    value: function () {
      var _loadFromArray = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(tagIdOrOptionsOrParams, optionsOrIndex, index) {
        var params;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!isParams(tagIdOrOptionsOrParams)) {
                  params = {};

                  if (isString(tagIdOrOptionsOrParams)) {
                    params.id = tagIdOrOptionsOrParams;
                  } else {
                    params.options = tagIdOrOptionsOrParams;
                  }

                  if (isNumber(optionsOrIndex)) {
                    params.index = optionsOrIndex;
                  } else {
                    params.options = optionsOrIndex !== null && optionsOrIndex !== void 0 ? optionsOrIndex : params.options;
                  }

                  params.index = index !== null && index !== void 0 ? index : params.index;
                } else {
                  params = tagIdOrOptionsOrParams;
                }

                return _context9.abrupt("return", this._loadParams(params));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function loadFromArray(_x20, _x21, _x22) {
        return _loadFromArray.apply(this, arguments);
      }

      return loadFromArray;
    }()
  }, {
    key: "loadJSON",
    value: function () {
      var _loadJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(tagId, pathConfigJson, index) {
        var url, id;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (isNumber(pathConfigJson) || pathConfigJson === undefined) {
                  url = tagId;
                } else {
                  id = tagId;
                  url = pathConfigJson;
                }

                return _context10.abrupt("return", this._loadParams({
                  id: id,
                  url: url,
                  index: index
                }));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function loadJSON(_x23, _x24, _x25) {
        return _loadJSON.apply(this, arguments);
      }

      return loadJSON;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _refresh,
            _args11 = arguments;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _refresh = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : true;

                if (_refresh) {
                  _context11.next = 3;
                  break;
                }

                return _context11.abrupt("return");

              case 3:
                this.dom().forEach(function (t) {
                  return t.refresh();
                });

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function refresh() {
        return _refresh2.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      this._eventDispatcher.removeEventListener(type, listener);
    }
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(id, element, options, index) {
        var params;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                params = {
                  index: index
                };

                if (isString(id)) {
                  params.id = id;
                } else {
                  params.element = id;
                }

                if (element instanceof HTMLElement) {
                  params.element = element;
                } else {
                  params.options = element;
                }

                if (isNumber(options)) {
                  params.index = options;
                } else {
                  params.options = options !== null && options !== void 0 ? options : params.options;
                }

                return _context12.abrupt("return", this._loadParams(params));

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function set(_x26, _x27, _x28, _x29) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "setJSON",
    value: function () {
      var _setJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(id, element, pathConfigJson, index) {
        var params;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                params = {};

                if (id instanceof HTMLElement) {
                  params.element = id;
                  params.url = element;
                  params.index = pathConfigJson;
                } else {
                  params.id = id;
                  params.element = element;
                  params.url = pathConfigJson;
                  params.index = index;
                }

                return _context13.abrupt("return", this._loadParams(params));

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function setJSON(_x30, _x31, _x32, _x33) {
        return _setJSON.apply(this, arguments);
      }

      return setJSON;
    }()
  }, {
    key: "setOnClickHandler",
    value: function setOnClickHandler(callback) {
      var dom = this.dom();

      if (!dom.length) {
        throw new Error("".concat(errorPrefix, " can only set click handlers after calling tsParticles.load()"));
      }

      var _iterator2 = _createForOfIteratorHelper(dom),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var domItem = _step2.value;
          domItem.addClickHandler(callback);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "_loadParams",
    value: function () {
      var _loadParams2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(params) {
        var _params$id, _params$element;

        var id, index, url, options, domContainer, currentOptions, dom, oldIndex, old, canvasEl, existingCanvases, newItem;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                id = (_params$id = params.id) !== null && _params$id !== void 0 ? _params$id : "tsparticles".concat(Math.floor(getRandom() * 10000));
                index = params.index;
                url = params.url;

                if (!url) {
                  _context14.next = 9;
                  break;
                }

                _context14.next = 6;
                return getDataFromUrl({
                  fallback: params.options,
                  url: url,
                  index: index
                });

              case 6:
                _context14.t0 = _context14.sent;
                _context14.next = 10;
                break;

              case 9:
                _context14.t0 = params.options;

              case 10:
                options = _context14.t0;
                domContainer = (_params$element = params.element) !== null && _params$element !== void 0 ? _params$element : document.getElementById(id);

                if (!domContainer) {
                  domContainer = document.createElement("div");
                  domContainer.id = id;
                  document.body.append(domContainer);
                }

                currentOptions = itemFromSingleOrMultiple(options, index), dom = this.dom(), oldIndex = dom.findIndex(function (v) {
                  return v.id === id;
                });

                if (oldIndex >= 0) {
                  old = this.domItem(oldIndex);

                  if (old && !old.destroyed) {
                    old.destroy();
                    dom.splice(oldIndex, 1);
                  }
                }

                if (domContainer.tagName.toLowerCase() === "canvas") {
                  canvasEl = domContainer;
                  canvasEl.dataset[generatedAttribute] = "false";
                } else {
                  existingCanvases = domContainer.getElementsByTagName("canvas");

                  if (existingCanvases.length) {
                    canvasEl = existingCanvases[0];
                    canvasEl.dataset[generatedAttribute] = "false";
                  } else {
                    canvasEl = document.createElement("canvas");
                    canvasEl.dataset[generatedAttribute] = "true";
                    domContainer.appendChild(canvasEl);
                  }
                }

                if (!canvasEl.style.width) {
                  canvasEl.style.width = "100%";
                }

                if (!canvasEl.style.height) {
                  canvasEl.style.height = "100%";
                }

                newItem = new Container(this, id, currentOptions);

                if (oldIndex >= 0) {
                  dom.splice(oldIndex, 0, newItem);
                } else {
                  dom.push(newItem);
                }

                newItem.canvas.loadCanvas(canvasEl);
                _context14.next = 23;
                return newItem.start();

              case 23:
                return _context14.abrupt("return", newItem);

              case 24:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function _loadParams(_x34) {
        return _loadParams2.apply(this, arguments);
      }

      return _loadParams;
    }()
  }]);

  return Engine;
}();